
export { default as EnvelopeClosedFillIcon } from "./EnvelopeClosedFill.js"
export { default as EnvelopeClosedIcon } from "./EnvelopeClosed.js"